const checkIfValidChild = ({ identifier }) => {
  if (!identifier || identifier !== 'accordion-item') {
    throw new Error(`
			You are trying to render a component as a direct child of <Accordion>
			That is not an <Accordion.Item>\n If you need additional markup alongside the
			items, pass in children as function or a render prop
		`);
  }
};

export default checkIfValidChild;
